import { EventDetailsList } from "./EventDetailsList";

export default EventDetailsList;
